import { createSlice } from "@reduxjs/toolkit";

const authUser = {
  user: {},
  accessToken: "",
  isLoggedIn: false,
  favorites: [],
  favoriteList: [],
  messageCount: 0,
  notificationCount: 0,
  stripeAccount: {
    hasAccount: false,
    isComplete: false,
    detailsSubmitted: false,
    chargesEnabled: false,
    payoutsEnabled: false,
  },
  stripeBalance: {
    available: 0,
    pending: 0,
    instant_available: 0,
    totalEarnings: 0,
    paidOut: 0,
    inConnectedAccount: 0,
  },
  payoutsHistory: [],
};

const AuthSlice = createSlice({
  name: "auth",
  initialState: authUser,
  reducers: {
    updateNotiCount: (state, action) => {
      state.messageCount = action.payload.messageCount;
      state.notificationCount = action.payload.notificationCount;
    },
    getFavoritesList: (state, action) => {
      state.favoriteList = action.payload.items;
    },
    getFavorites: (state, action) => {
      state.favorites = action.payload.items;
    },
    updateFavorites: (state, action) => {
      let curState = [...state.favorites];
      const spaceId = action.payload.id;

      if (!curState.includes(spaceId)) {
        curState.push(spaceId);
      } else {
        curState = curState.filter((item) => item !== spaceId);
      }

      state.favorites = curState;
    },
    loginUser: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.isLoggedIn = action.payload.isLoggedIn;
    },
    updateUser: (state, action) => {
      state.user = action.payload.user;
    },
    logoutUser: (state) => {
      state.user = {};
      state.accessToken = "";
      state.isLoggedIn = false;
    },

    updateStripeAccount: (state: any, action: any) => {
      state.stripeAccount = action.payload.data;
    },
    updateStripeBalance: (state: any, action: any) => {
      state.stripeBalance = { ...state.stripeBalance, ...action.payload.data };
    },
    getPayoutHistoryList: (state, action) => {
      state.payoutsHistory = action.payload.items;
    },
  },
});

export const {
  loginUser,
  updateUser,
  logoutUser,
  updateNotiCount,
  getFavorites,
  getFavoritesList,
  updateFavorites,
  updateStripeAccount,
  updateStripeBalance,
  getPayoutHistoryList,
} = AuthSlice.actions;

export default AuthSlice.reducer;
